module.exports = __webpack_public_path__ + "img/6.fae0ad9e.png";